import { MilestoneEditForm } from '../../../milestone/types/milestone-types'

export const getMilestoneInitialValues = (form?: MilestoneEditForm) => {
  if (form) {
    return {
      name: form.name,
      users: form.users,
      mobileApp: form.mobileApp,
      shouldBeChecked: form.shouldBeChecked,
    }
  }

  return {
    name: null,
    users: null,
    mobileApp: false,
    shouldBeChecked: false,
  }
}
